<div class="icon-picker" [class.is-open]="open">
    <div class="input-group" [class.input-group-sm]="size === 'sm'">
        <span class="input-group-text icon-picker-preview" [class.is-missing]="!exists"
            ngbTooltip="{{(exists ? 't-icon-picker.t-preview' : 't-icon-picker.t-not-found') | translate}}">
            <i class="{{previewClass}}"></i>
        </span>
        <input type="text" class="form-control" [class.is-invalid]="!exists" [value]="value" [placeholder]="placeholder"
            [disabled]="disabled" (input)="onInput($any($event.target).value)" (blur)="onBlur()" (focus)="openPanel()">
        <button type="button" class="btn btn-soft-secondary" *ngIf="value && !disabled" (click)="clear()"
            ngbTooltip="{{'t-icon-picker.t-clear' | translate}}"><i class="ri-close-line"></i></button>
        <button type="button" class="btn" [ngClass]="open ? 'btn-primary' : 'btn-soft-primary'" [disabled]="disabled"
            (click)="togglePanel()" ngbTooltip="{{'t-icon-picker.t-browse' | translate}}">
            <i class="ri-apps-2-line"></i>
        </button>
    </div>

    <div class="icon-picker-panel" *ngIf="open">
        <div class="icon-picker-panel-head">
            <div class="search-box flex-grow-1">
                <input type="text" class="form-control" [value]="searchTerm" #searchInput
                    (input)="onSearch($any($event.target).value)" placeholder="{{'t-icon-picker.t-search' | translate}}">
                <i class="ri-search-line search-icon"></i>
            </div>
            <button type="button" class="btn btn-sm btn-ghost-secondary" (click)="closePanel()"><i class="ri-close-line"></i></button>
        </div>
        <div class="icon-picker-libs">
            <button type="button" class="icon-picker-lib" [class.is-active]="library === 'all'" (click)="setLibrary('all')">
                {{'t-icon-picker.t-all' | translate}}
            </button>
            <button type="button" class="icon-picker-lib" *ngFor="let lib of libraries" [class.is-active]="library === lib.id"
                (click)="setLibrary(lib.id)">{{lib.label}} <small *ngIf="counts[lib.id]">({{counts[lib.id]}})</small></button>
        </div>

        <div class="icon-picker-grid" *ngIf="results.length">
            <button type="button" class="icon-picker-item" *ngFor="let entry of results; trackBy: trackEntry"
                [class.is-active]="value === entry.cls || value === entry.name" [title]="entry.cls"
                (click)="pick(entry)"><i class="{{entry.cls}}"></i></button>
        </div>
        <p class="text-muted small text-center my-3" *ngIf="!results.length">{{'t-icon-picker.t-no-results' | translate}}</p>

        <div class="icon-picker-footer">
            <span>{{'t-icon-picker.t-showing' | translate: {shown: results.length, total: total} }}
                <a href="javascript:void(0)" *ngIf="results.length < total" (click)="showMore()">{{'t-icon-picker.t-more' | translate}}</a>
            </span>
            <span>
                <a *ngFor="let lib of libraries" [href]="lib.reference" target="_blank" rel="noopener">{{lib.label}} <i class="ri-external-link-line"></i></a>
            </span>
        </div>
    </div>
</div>
